import gql from 'graphql-tag';

export const UserConnectionFragment = gql`
  fragment UserConnectionFragment on UserConnections {
    following
    followers
  }
`;
